
import React, {Component} from 'react';


import { withRouter } from "react-router-dom";
//import auth0Client from '../Auth';

class Support extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
        questions: null,
        checkingSession: true,
      };
    }
    async componentDidMount() {

       
         
      }
    
    render() {
        return(
           
            <div> 
  
           <h5> Support </h5>
           
            <br/>
            <p class="text-primary">Email customer support.  Will respond within 1 business day. If this is an high-priority support issue, call <b>(847) 881-6310</b></p>
            <br/>
            <a href='mailto:support@bounte.net'>  <h6 className='text-info'>Email Customer Support</h6></a>

            
             
                
        </div>
           
            
        )
       
    }




}


export default withRouter(Support);
